"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OFFSET_A = exports.OFFSET_B = exports.OFFSET_G = exports.OFFSET_R = void 0;
exports.newColor = newColor;
exports.from = from;
exports.toNumber = toNumber;
exports.getRed = getRed;
exports.getGreen = getGreen;
exports.getBlue = getBlue;
exports.getAlpha = getAlpha;
exports.setRed = setRed;
exports.setGreen = setGreen;
exports.setBlue = setBlue;
exports.setAlpha = setAlpha;
const bit = __importStar(require("./bit"));
const {
  cast,
  get,
  set
} = bit;
exports.OFFSET_R = 24;
exports.OFFSET_G = 16;
exports.OFFSET_B = 8;
exports.OFFSET_A = 0;
/**
 * Creates a new color from the given RGBA components.
 * Every component should be in the [0, 255] range.
 */
function newColor(r, g, b, a) {
  return (r << exports.OFFSET_R) + (g << exports.OFFSET_G) + (b << exports.OFFSET_B) + (a << exports.OFFSET_A);
}
/**
 * Creates a new color from the given number value, e.g. 0x599eff.
 */
function from(color) {
  return newColor(get(color, exports.OFFSET_R), get(color, exports.OFFSET_G), get(color, exports.OFFSET_B), get(color, exports.OFFSET_A));
}
/**
 * Turns the color into its equivalent number representation.
 * This is essentially a cast from int32 to uint32.
 */
function toNumber(color) {
  return cast(color);
}
function getRed(c) {
  return get(c, exports.OFFSET_R);
}
function getGreen(c) {
  return get(c, exports.OFFSET_G);
}
function getBlue(c) {
  return get(c, exports.OFFSET_B);
}
function getAlpha(c) {
  return get(c, exports.OFFSET_A);
}
function setRed(c, value) {
  return set(c, exports.OFFSET_R, value);
}
function setGreen(c, value) {
  return set(c, exports.OFFSET_G, value);
}
function setBlue(c, value) {
  return set(c, exports.OFFSET_B, value);
}
function setAlpha(c, value) {
  return set(c, exports.OFFSET_A, value);
}
